import { useEffect, useState } from 'react';

import { isInitialState, addInitialStateCallback, removeInitialStateCallback } from '@utils/isInitialState.ts';

/**
 * Hook to determine whether the app is in its initial state (no user interaction yet)
 * @param {*} reloadCondition , if there is no reloadCondition, the hook will be a live listener, otherwise it will only check on changes to the reloadCondition
 * @returns
 */
const useIsInitialState = (reloadCondition = []) => {
  const [isInitial, setIsInitial] = useState(isInitialState());
  useEffect(() => {
    if (reloadCondition) {
      setIsInitial(isInitialState());
      return;
    }
    // live listener when no reload condition
    addInitialStateCallback(setIsInitial);
    return () => {
      removeInitialStateCallback(setIsInitial);
    };
  }, reloadCondition);
  return isInitial;
};

export { useIsInitialState };
